<template>
  <div id="container" class="cs_st grid-container">
    <!-- TODO: Should use Subbar component -->
    <BaseLocation current-group-name="information" />
    <!-- Location END -->
    <div class="section fill">
      <div class="inner">
        <h2>{{ $t('views.help.sitemap.9694') }}</h2>
        <p class="sub">{{ $t('views.help.sitemap.subtitle') }}</p>
        <div class="select_area">
          <div class="select_item" :class="{ active: showSelectList }">
            <button
              v-on-clickaway="closeShowList"
              class="select_option"
              @click="toggleShowList"
            >
              <span v-if="!selectSite" class="txt">사이트맵 선택</span>
              <span v-else>{{ selectSite.title }}</span>
              <span class="arrow blind">열기</span>
            </button>
            <ul class="select_list">
              <li class="tit">
                {{ selectSite.title }}
                <button type="button" class="select_list_close an_a">
                  <span class="svg_close"></span>
                  <span class="an_t">닫기</span>
                </button>
              </li>

              <li v-for="(site, idx) in siteMap" :key="idx">
                <button
                  type="button"
                  class="list_option"
                  :class="{ active: selectSite.id === site.id }"
                  @click="selectedSite(site)"
                >
                  <span>{{ site.title }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <ul class="sitemap">
          <!--모바일 세로모드에서 드롭다운 메뉴-->
          <li class="cat_list" :class="{ active: selectSite.id === 0 }">
            <h3>{{ $t('views.help.sitemap.2985') }}</h3>
            <ul class="detail_list">
              <li>
                <router-link :to="{ name: 'search' }">{{
                  $t('views.help.sitemap.search')
                }}</router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'books_category', params: { category: 'new' } }"
                  >신간도서</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'books_category',
                    params: { category: 'popular' }
                  }"
                  >베스트 셀러</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'books_category',
                    params: { category: 'recommended' }
                  }"
                  >{{ $t('views.help.sitemap.6695') }}</router-link
                >
              </li>
            </ul>
          </li>
          <li class="cat_list" :class="{ active: selectSite.id === 1 }">
            <h3>{{ $t('views.help.sitemap.7718') }}</h3>
            <ul class="detail_list">
              <li>
                <router-link :to="{ name: 'library' }">{{
                  $t('views.help.sitemap.683')
                }}</router-link>
              </li>
              <li>
                <!-- <router-link :to="{ name: 'library' }">증정본 서재</router-link> -->
                <a @click="goPresentBs">증정본 서재</a>
              </li>
            </ul>
          </li>
          <li class="cat_list" :class="{ active: selectSite.id === 2 }">
            <h3>교강사 전용</h3>
            <ul class="detail_list">
              <li>
                <router-link :to="{ name: 'postPresent' }"
                  >증정코드 입력</router-link
                >
              </li>
              <li>
                <router-link :to="{ name: 'present' }">증정 요청</router-link>
              </li>
            </ul>
          </li>
          <li class="cat_list" :class="{ active: selectSite.id === 3 }">
            <h3>{{ $t('views.help.sitemap.9357') }}</h3>
            <ul class="detail_list">
              <li>
                <router-link :to="{ name: 'faq' }">{{
                  $t('common.footer.7188')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'events' }">{{
                  $t('views.help.sitemap.5830')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'notices' }">{{
                  $t('views.help.sitemap.6199')
                }}</router-link>
              </li>
            </ul>
          </li>
          <li class="cat_list" :class="{ active: selectSite.id === 4 }">
            <h3>{{ $t('views.help.sitemap.4790') }}</h3>
            <ul class="detail_list">
              <li>
                <router-link :to="{ name: 'terms' }">{{
                  $t('views.help.sitemap.3220')
                }}</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'privacy' }">{{
                  $t('views.help.sitemap.6606')
                }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- <transition name="slide-right"> -->
    <Sidebar />
    <!-- </transition> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BOOKSHELF_GET_LIST } from '@/store/types'

export default {
  name: 'Sitemap',
  data() {
    return {
      showSelectList: false,
      siteMap: [
        { id: 0, title: '스토어' },
        { id: 1, title: '내서재' },
        { id: 2, title: '교강사 전용' },
        { id: 3, title: '고객센터' },
        { id: 4, title: '이용안내' }
      ],
      selectSite: { id: 0, title: '스토어' }
    }
  },
  computed: {
    ...mapGetters(['isSidebarOpen', 'getBookshelves'])
  },
  methods: {
    selectedSite(site) {
      this.selectSite = site
      this.showSelectList = false
    },
    toggleShowList() {
      this.showSelectList = !this.showSelectList
    },
    closeShowList() {
      this.showSelectList = false
    },

    async goPresentBs() {
      await this.$store.dispatch(BOOKSHELF_GET_LIST)
      this.$router.push({
        name: 'library',
        params: {
          id:
            this.getBookshelves.find((e) => e.bookshelfTp === 'PRS')
              ?.bookshelfId || ''
        }
      })
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
//Remove when 전자도서관 section is back
.cs_st .sitemap .cat_list {
  width: 20%;
}

.select_area {
  margin-top: 24px;
  border: 1px solid #d5dff3;
  border-radius: 4px;
  display: none;
}
.inner .select_option,
.ly_inner .select_option {
  width: 100%;
}
@media (max-width: 767px) {
  .select_area {
    display: block;
  }
  .cs_st .sitemap .cat_list {
    display: none;
  }
  .cs_st .sitemap .cat_list.active {
    display: block;
    width: 100%;
  }
}
</style>
